export const WEDDING = {
  bride: "Büşra Yüksel",
  groom: "Furkan Ziyad Çelik",
  initials: "B | F",
  dateISO: "2026-11-15T13:00:00+03:00",
  flight: {
    no: "BF1607",
    from: "IST",
    fromCity: "İstanbul",
    to: "SAL",
    toCity: "El Salvador",
    date: "15 NOV 2026",
    boarding: "13:00",
    gate: "HİCRET",
    seat: "34S",
  },
  whatsapp: "+90 530 409 8815",
  iban: "TR140020500009154750800001",
  ibanName: "Furkan Çelik",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Ba%C5%9Fak+D%C3%BC%C4%9F%C3%BCn+Salonu+Ba%C5%9Fak%C5%9Fehir+%C4%B0stanbul",
};

export const CONTENT = {
  tr: {
    cover: {
      kicker: "DÜĞÜN DAVETİYESİ",
      title: "PASSPORT",
      subtitle: "Wedding Invitation",
      open: "Davetiyeyi Aç",
      hint: "Pasaporta dokunun",
      flip: "Çevir",
    },
    journey: {
      chapter: "01 — DAVET",
      title: "Muhabbetle Başlayan Bir Ömür",
      script: "",
      body: "Hayatımızın en güzel yolculuğuna çıkarken sizi de yanımızda görmek isteriz. Varlığınız bu yeni sayfayı bizim için çok daha anlamlı kılacak.",
      when: "PAZAR",
      whenDate: "15 KASIM 2026",
      time: "13:00",
      venue: "BAŞAK DÜĞÜN SALONU",
      address:
        "Başak Mah. 5. Etap Vadi Center yanı, Burger King arkası, Ali Soylu Cd., 34480 Başakşehir / İstanbul / Türkiye",
      families: "AİLELER",
      groomSide: "DAMAT AİLESİ",
      brideSide: "GELİN AİLESİ",
      groomParents: "Tuncay - Saliha",
      brideParents: "Turan - Rabia",
      map: "Konumu Aç",
    },
    countdown: {
      chapter: "02 — GERİ SAYIM",
      title: "Kalkışa Kalan Süre",
      days: "GÜN",
      hours: "SAAT",
      mins: "DAKİKA",
      secs: "SANİYE",
      done: "Bugün o gün!",
    },
    boarding: {
      chapter: "03 — BİNİŞ KARTI",
      airline: "WEDDING AIRLINES",
      pass: "BİNİŞ KARTI",
      passengers: "YOLCULAR",
      from: "KALKIŞ",
      to: "VARIŞ",
      flight: "UÇUŞ NO",
      date: "TARİH",
      boardingTime: "BİNİŞ SAATİ",
      gate: "KAPI",
      seat: "KOLTUK",
      footer: "BİRLİKTE OLMAK EN SEVDİĞİMİZ ROTA",
      addToCalendar: "Takvime Ekle",
    },
    program: {
      chapter: "04 — PROGRAM",
      title: "Program Akışı",
      items: [
        { time: "13:00", tr: "Aşr-ı Şerif — Dua", en: "Kur'an Tilaveti - Dua", icon: "book" },
        { time: "14:00", tr: "Yemek İkramı", en: "Yemek İkramı", icon: "utensils" },
        { time: "16:00", tr: "Takı Töreni", en: "Takı Merasimi", icon: "gift" },
        { time: "17:00", tr: "Program Bitişi", en: "Programın Sonu", icon: "mail" },
      ],
    },
    rsvp: {
      chapter: "05 — LÜTFEN YANITLAYIN",
      title: "Katılım Bildirimi",
      note: "Lütfen 31 Ekim 2026 tarihine kadar bildiriniz.",
      name: "Ad Soyad",
      namePh: "Adınız ve soyadınız",
      status: "Katılım Durumu",
      accept: "Katılacağım",
      decline: "Katılamayacağım",
      guests: "Kişi Sayısı",
      contact: "İletişim (Telefon)",
      contactPh: "Telefon numaranız",
      message: "Mesajınız",
      messagePh: "Çifte iletmek istediğiniz not (opsiyonel)",
      submit: "Bildirimi Gönder",
      sending: "Gönderiliyor...",
      success: "Teşekkürler! Bildiriminiz alındı.",
      error: "Bir hata oluştu, tekrar deneyin.",
      required: "Lütfen adınızı girin ve katılım durumunu seçin.",
      downloadCard: "Kartı İndir",
      cardDownloaded: "Biniş kartınız indirildi ✈",
    },
    guestbook: {
      chapter: "06 — ANILAR",
      title: "Anılarınızı Paylaşın",
      note: "Düğünümüzden çektiğiniz fotoğrafları ve duygularınızı bizimle paylaşın. Anılarınız bize ulaşacak.",
      name: "Ad Soyad",
      namePh: "Adınız ve soyadınız",
      message: "Duygularınız",
      messagePh: "Bize iletmek istediğiniz mesaj...",
      photos: "Fotoğraflar",
      photoHint: "En fazla 5 fotoğraf · her biri en çok 10MB",
      addPhotos: "Fotoğraf Seç",
      submit: "Paylaş",
      sending: "Yükleniyor...",
      success: "Teşekkürler! Anınız bizimle paylaşıldı ❤",
      error: "Bir hata oluştu, tekrar deneyin.",
      required: "Lütfen adınızı girin.",
      needContent: "Bir mesaj yazın veya fotoğraf ekleyin.",
      tooMany: "En fazla 5 fotoğraf yükleyebilirsiniz.",
      tooBig: "Her fotoğraf en çok 10MB olabilir.",
      again: "Yeni Anı Paylaş",
    },
    gift: {
      chapter: "07 — TEBRİK & KATKI",
      title: "Düğün Tebriği & Katkı",
      note: "Bizi mutlu etmek ve yeni yuvamıza katkıda bulunmak isterseniz, aşağıdaki IBAN'a hediyenizi gönderebilirsiniz. Varlığınız bizim için en büyük hediye.",
      ibanLabel: "IBAN",
      nameLabel: "Hesap Sahibi",
      copyIban: "IBAN'ı Kopyala",
      copyName: "İsmi Kopyala",
      copied: "Kopyalandı!",
      cardTitle: "Kart ile Katkı",
      cardBtn: "Kart ile Katkı Yap",
      cardSoon: "Kart ile ödeme yakında aktif olacak.",
      cardAmountPh: "Tutar (₺)",
      noteTitle: "Tebrik Notu Bırakın",
      name: "Ad Soyad",
      namePh: "Adınız ve soyadınız",
      message: "Tebrik Mesajınız",
      messagePh: "Çifte iletmek istediğiniz güzel dilekler...",
      amount: "Katkı Tutarı (opsiyonel)",
      amountPh: "Örn. 1000 ₺",
      submit: "Tebriği Gönder",
      sending: "Gönderiliyor...",
      success: "Teşekkürler! Tebrikiniz alındı ❤",
      error: "Bir hata oluştu, tekrar deneyin.",
      required: "Lütfen adınızı girin.",
      again: "Yeni Tebrik Gönder",
    },
    footer: {
      closing: "Sizi Bekliyoruz",
      script: "We Can't Wait to See You!",
      contact: "İLETİŞİM",
    },
  },
  en: {
    cover: {
      kicker: "WEDDING INVITATION",
      title: "PASSPORT",
      subtitle: "Düğün Davetiyesi",
      open: "Open Invitation",
      hint: "Tap the passport",
      flip: "Flip",
    },
    journey: {
      chapter: "01 — INVITATION",
      title: "A Lifetime Begun with Love",
      script: "",
      body: "We warmly invite you to join us as we embark on the greatest journey of our lives. Your presence will make this new chapter even more memorable.",
      when: "SUNDAY",
      whenDate: "15 NOVEMBER 2026",
      time: "1:00 PM",
      venue: "BAŞAK WEDDING HALL",
      address:
        "Başak Mah. 5. Etap Vadi Center, behind Burger King, Ali Soylu Cd., 34480 Başakşehir / İstanbul / Türkiye",
      families: "FAMILIES",
      groomSide: "GROOM'S SIDE",
      brideSide: "BRIDE'S SIDE",
      groomParents: "Tuncay - Saliha",
      brideParents: "Turan - Rabia",
      map: "Open Location",
    },
    countdown: {
      chapter: "02 — COUNTDOWN",
      title: "Time Until Departure",
      days: "DAYS",
      hours: "HOURS",
      mins: "MINUTES",
      secs: "SECONDS",
      done: "Today is the day!",
    },
    boarding: {
      chapter: "03 — BOARDING PASS",
      airline: "WEDDING AIRLINES",
      pass: "BOARDING PASS",
      passengers: "PASSENGERS",
      from: "FROM",
      to: "TO",
      flight: "FLIGHT",
      date: "DATE",
      boardingTime: "BOARDING TIME",
      gate: "GATE",
      seat: "SEAT",
      footer: "TOGETHER IS OUR FAVORITE DESTINATION",
      addToCalendar: "Add to Calendar",
    },
    program: {
      chapter: "04 — SCHEDULE",
      title: "Program Schedule",
      items: [
        { time: "1:00 PM", tr: "Quran Recitation - Prayer", en: "Quran Recitation - Prayer", icon: "book" },
        { time: "2:00 PM", tr: "Dinner", en: "Dinner", icon: "utensils" },
        { time: "4:00 PM", tr: "Gift Ceremony", en: "Gift Ceremony", icon: "gift" },
        { time: "5:00 PM", tr: "End of Program", en: "End of Program", icon: "mail" },
      ],
    },
    rsvp: {
      chapter: "05 — PLEASE REPLY",
      title: "RSVP",
      note: "Please kindly reply by 31 October 2026.",
      name: "Full Name",
      namePh: "Your full name",
      status: "Attendance",
      accept: "Joyfully Accepts",
      decline: "Regretfully Declines",
      guests: "Number of Guests",
      contact: "Contact (Phone)",
      contactPh: "Your phone number",
      message: "Your Message",
      messagePh: "A note for the couple (optional)",
      submit: "Send RSVP",
      sending: "Sending...",
      success: "Thank you! Your RSVP has been received.",
      error: "Something went wrong, please try again.",
      required: "Please enter your name and select attendance.",
      downloadCard: "Download Pass",
      cardDownloaded: "Your boarding pass has been downloaded ✈",
    },
    guestbook: {
      chapter: "06 — MEMORIES",
      title: "Share Your Memories",
      note: "Share the photos you took at our wedding and your thoughts with us. Your memories will reach us.",
      name: "Full Name",
      namePh: "Your full name",
      message: "Your Thoughts",
      messagePh: "A message you'd like to share with us...",
      photos: "Photos",
      photoHint: "Up to 5 photos · max 10MB each",
      addPhotos: "Choose Photos",
      submit: "Share",
      sending: "Uploading...",
      success: "Thank you! Your memory has been shared ❤",
      error: "Something went wrong, please try again.",
      required: "Please enter your name.",
      needContent: "Write a message or add a photo.",
      tooMany: "You can upload up to 5 photos.",
      tooBig: "Each photo can be at most 10MB.",
      again: "Share Another Memory",
    },
    gift: {
      chapter: "07 — GIFT & BLESSINGS",
      title: "Gifts & Blessings",
      note: "If you would like to contribute to our new home, you may send your gift to the IBAN below. Your presence is the greatest gift of all.",
      ibanLabel: "IBAN",
      nameLabel: "Account Holder",
      copyIban: "Copy IBAN",
      copyName: "Copy Name",
      copied: "Copied!",
      cardTitle: "Contribute by Card",
      cardBtn: "Contribute by Card",
      cardSoon: "Card payments will be available soon.",
      cardAmountPh: "Amount (₺)",
      noteTitle: "Leave a Blessing",
      name: "Full Name",
      namePh: "Your full name",
      message: "Your Message",
      messagePh: "Warm wishes you'd like to share with the couple...",
      amount: "Gift Amount (optional)",
      amountPh: "e.g. 1000 ₺",
      submit: "Send Blessing",
      sending: "Sending...",
      success: "Thank you! Your blessing has been received ❤",
      error: "Something went wrong, please try again.",
      required: "Please enter your name.",
      again: "Send Another Blessing",
    },
    footer: {
      closing: "We Are Waiting For You",
      script: "We Can't Wait to See You!",
      contact: "CONTACT",
    },
  },
};
